<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData"   :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id"  @change="handleTableChange">
            <template slot="operation" slot-scope="text, record">
                
                <a-button v-if="record.disableflag == 1" type="link" @click="handleActive(record)">启用</a-button>
                <router-link class="tableLink" :to="{path:'detail_processor',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'edit_processor',query: {id: record.id,}}">编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
            <template slot="domainNames" slot-scope="text">
                <span >{{ domainName[text] }}</span>
            </template>
        </a-table>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};

const domainName = {
    '001':'前台',
    '002':'中台',
    '003':'开放',
    '004':'基础',
}


export default {
    data() {
        return {
            columns:[],
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            ordercoloum:'total',
            orderstr:'desc',
            searchP:{},
            platforms:[],
            domainName
        };
    },
    methods: {
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.ordercoloum = sorter.field ;
                this.orderstr = sorter.order.replace('end','');
            }
            else{
                this.ordercoloum = '';
                this.orderstr = '';
            }

            this.getAppSumData();
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleActive(item){
            let that = this;
            that.$store.dispatch({
                type: "servicekey/processorActive",
                params: {id: item.id,domain:item.domain}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
        },
        handleDelete(item){
            let that = this;
            that.$store.dispatch({
                type: "servicekey/processorDel",
                params: {id: item.id,domain:item.domain}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
            
        },
        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "servicekey/processorQueryListPage",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            if(searchP.domain == '003'){
                //开发 不展示 path、sign列
                this.columns = [
                    {
                        title: "序号",
                        width: 50,
                        align: "center",
                        customRender: (text, record, index) => {
                            let { page, pageSize } = pagination;
                            return (Number(page) - 1) * Number(pageSize) + index + 1;
                        }
                    },
    
                    {
                        title: "所属领域",
                        dataIndex: "domain",
                        align: "center",
                        scopedSlots: { customRender: 'domainNames' },
                        width:80
                    },
                    {
                        title: "版本",
                        dataIndex: "version",
                        align: "center",
                        width:80
                    },
                    {
                        title: "类名",
                        dataIndex: "classname",
                        align: "center",
                        width:400,
                        ellipsis: true,
                    },
                    // {
                    //     title: "是否禁用",
                    //     dataIndex: "disableflag",
                    //     align: "center",
                    //     width:100,
                    //     customRender:text => {
                    //         return text == '1' ? '禁用' : '不禁用'
                    //     },
                    //     ellipsis: true,
                    // },
                    // {
                    //     title: "path",
                    //     dataIndex: "path",
                    //     align: "center",
                    //     width:200,
                    //     ellipsis: true,
                    // },
                    // {
                    //     title: "sign",
                    //     dataIndex: "sign",
                    //     align: "center",
                    //     width:200,
                    //     ellipsis: true,
                    // },
                    {
                        title: "servicekey",
                        dataIndex: "servicekey",
                        align: "center",
                        width:200,
                        ellipsis: true,
                    },
                    {
                        title: "module",
                        dataIndex: "module",
                        align: "center",
                        width:200,
                        ellipsis: true,
                    },
                    {
                        title: "备注",
                        dataIndex: "remark",
                        align: "center",
                        width:120,
                        ellipsis: true,
                    },
                    {
                        title: "状态",
                        dataIndex: "status",
                        align: "center",
                        width:100,
                        customRender:text => {
                            if(text == 'normal'){
                                return '正常' 
                            }
                            else if(text == 'error'){
                                return '异常'
                            }
                            else{
                                return '未知'
                            }   
                        },
                        ellipsis: true,
                    },


                    {
                        title: '操作',
                        dataIndex: 'operation',
                        align: 'center',
                        width: 150,
                        scopedSlots: { customRender: 'operation' },
                    }

                ];
            }
            else{
                this.columns = [
                    {
                        title: "序号",
                        width: 50,
                        align: "center",
                        customRender: (text, record, index) => {
                            let { page, pageSize } = pagination;
                            return (Number(page) - 1) * Number(pageSize) + index + 1;
                        }
                    },
    
                    {
                        title: "所属领域",
                        dataIndex: "domain",
                        align: "center",
                        scopedSlots: { customRender: 'domainNames' },
                        width:80
                    },
                    {
                        title: "版本",
                        dataIndex: "version",
                        align: "center",
                        width:80
                    },
                    {
                        title: "类名",
                        dataIndex: "classname",
                        align: "center",
                        width:400,
                        ellipsis: true,
                    },
                    // {
                    //     title: "是否禁用",
                    //     dataIndex: "disableflag",
                    //     align: "center",
                    //     width:100,
                    //     customRender:text => {
                    //         return text == '1' ? '禁用' : '不禁用'
                    //     },
                    //     ellipsis: true,
                    // },
                    {
                        title: "path",
                        dataIndex: "path",
                        align: "center",
                        width:200,
                        ellipsis: true,
                    },
                    {
                        title: "sign",
                        dataIndex: "sign",
                        align: "center",
                        width:200,
                        ellipsis: true,
                    },
                    // {
                    //     title: "servicekey",
                    //     dataIndex: "servicekey",
                    //     align: "center",
                    //     width:200,
                    //     ellipsis: true,
                    // },
                    {
                        title: "module",
                        dataIndex: "module",
                        align: "center",
                        width:200,
                        ellipsis: true,
                    },
                    {
                        title: "备注",
                        dataIndex: "remark",
                        align: "center",
                        width:120,
                        ellipsis: true,
                    },
                    {
                        title: "状态",
                        dataIndex: "status",
                        align: "center",
                        width:100,
                        customRender:text => {
                            if(text == 'normal'){
                                return '正常' 
                            }
                            else if(text == 'error'){
                                return '异常'
                            }
                            else{
                                return '未知'
                            }   
                        },
                        ellipsis: true,
                    },


                    {
                        title: '操作',
                        dataIndex: 'operation',
                        align: 'center',
                        width: 150,
                        scopedSlots: { customRender: 'operation' },
                    }

                ];
            }
            this.getAppSumData();
        },
    },

    components:{
        
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

